import rehypeHighlight from 'rehype-highlight';

// @ts-ignore
function highlightSsr({ subset = false, ignoreMissing = true, ...rest } = {}) {
    return {
        rehype: (u) => u.use(rehypeHighlight, { subset, ignoreMissing, ...rest }),
    };
}

export { highlightSsr as default };
//# sourceMappingURL=index.esm.js.map
